export default "__VITE_ASSET__Bu90wg11__"